module.exports = __webpack_public_path__ + "img/level2addon_running.a325120d.png";